/** Français. See `en.ts` for what each key is and what it has to fit.
 *
 * The rail glyphs stay on the Latin WMO symbols; the pressure centers take
 * the French chart convention, A / D (anticyclone / dépression). */

import type { MessageKey } from "./en";

export const fr: Record<MessageKey, string> = {
  metaDescription:
    "Cartes météo en direct et gratuites dans le navigateur : prévisions GFS, ECMWF et AIFS, animations radar et satellite, trajectoires de typhons, radar 3D et émagrammes skew-T.",
  pageTitleLive: "Carte de prévision : {variable} · {model} {hours}H",
  pageTitleLiveObservation: "Carte d'observation : {variable} · {model} · dernières {hours} h",
  mapAria: "Carte mondiale de prévision de température et de précipitations",
  modelSwitchAria: "Jeu de données",
  variableSwitchAria: "Paramètre météorologique",
  varTemp: "2M",
  varPrecip: "TAUX",
  varWind: "10M",
  varSolar: "FLUX",
  varRadar: "CREF",
  varOrog: "OROG",
  varInfrared: "IR 10,4",
  varShortwave: "IR 3,9",
  varDustRgb: "RGB",
  varDustCf: "DEBRA",
  varZhouye: "ZHOUYE",
  varTrueColor: "COULEUR",
  varGust: "RAFALE",
  varCloud: "TOTALE",
  varCape: "SOL",
  varPwat: "COLONNE",
  varPtype: "TYPE",
  varCin: "INHIB",
  varHpbl: "HAUTEUR",
  varVis: "VISI",
  varDewPoint: "2M",
  varFeelsLike: "2M",
  varOmega: "VERT",
  varThetaE: "ÉQUIV",
  varCat: "EDR",
  varInflow: "AFFLUX",
  varFront: "FRONT",
  varHotspot: "FOYERS",
  varFfwi: "MÉTÉO FEU",
  varFwalert: "ALERTE",
  varSst: "PEAU",
  varIce: "COUV.",
  varWave: "HAUTEUR",
  varAod: "TOTALE",
  varPm: "2.5",
  varDustsfc: "SOL",
  varTsoil: "COUCHE 1",
  varSoilw: "COUCHE 1",
  varHumidity: "REL",
  varVapourFlux: "FLUX",
  varPressure: "NIV MER",
  varHeight: "GÉOP.",
  varPressureField: "CHAMP",
  varUnknownLayer: "COUCHE",

  glyphTmp2m: "T",
  glyphPrate: "R",
  glyphWind10m: "W",
  glyphDswrf: "S",
  glyphCref: "Z",
  glyphIr104: "I",
  glyphIr039: "C",
  glyphDustrgb: "P",
  glyphDustcf: "C",
  glyphZhouye: "Z",
  glyphTruecolor: "C",
  glyphGust: "G",
  glyphTcdc: "N",
  glyphCape: "C",
  glyphVis: "V",
  glyphPwat: "P",
  glyphCin: "I",
  glyphHpbl: "B",
  glyphPtype: "Y",
  glyphDpt2m: "D",
  glyphAptmp2m: "A",
  glyphVvel: "ω",
  glyphThetae: "θ",
  glyphCat: "ε",
  glyphInflow: "H",
  glyphFront: "F",
  glyphHotspot: "F",
  glyphFfwi: "M",
  glyphFwalert: "A",
  glyphTmpsfc: "S",
  glyphIce: "I",
  glyphWave: "H",
  glyphAod: "τ",
  glyphPm: "µ",
  glyphDustsfc: "P",
  glyphTsoil: "E",
  glyphSoilw: "M",
  glyphPressure: "P",
  glyphRh: "U",
  glyphQflux: "F",
  tipTemp: "Température",
  tipHumidity: "Humidité relative",
  tipWind: "Vent",
  tipPressure: "Pression et géopotentiel",
  tipVapourFlux: "Flux de vapeur d'eau",
  tipCloud: "Nébulosité",
  tipOmega: "Vitesse verticale",
  tipThetaE: "Température potentielle équivalente",
  tipCat: "Turbulence en air clair",
  tipIce: "Glace de mer",
  tipWave: "Vagues",
  tipAod: "Épaisseur optique des aérosols",
  tipPm: "Particules fines",
  tipTsoil: "Température du sol",
  tipSoilw: "Humidité du sol",
  tipSatellite: "Image satellite",
  levelSwitchAria: "Niveau",
  levelCaption: "Niveau",
  linesCaption: "Isolignes",
  accumCaption: "Cumul",
  accumRateGloss: "intensité",
  accumTotalGloss: "cumul {window}",
  modelHeading: "Jeux de données",
  linesRemoveTitle: "Appuyer de nouveau pour retirer les isolignes",
  fieldSectionAria: "Champ",
  overlaySectionAria: "Superpositions",
  markSectionAria: "Repères",
  tipMore: "Toutes les couches de ce run",
  varMore: "Couches",
  glyphMore: "+",
  fieldSheetAria: "Couches",
  fieldSheetHeading: "Couches",
  fieldGroupTemperature: "Température",
  fieldGroupMoisture: "Humidité",
  fieldGroupSoil: "Sol",
  fieldGroupWind: "Vent",
  fieldGroupDynamics: "Dynamique",
  fieldGroupRadiation: "Rayonnement & visibilité",
  fieldGroupAerosol: "Aérosols & qualité de l'air",
  fieldGroupOcean: "Océan",
  fieldGroupHydrology: "Cours d'eau et crues",
  fieldGroupSatellite: "Satellite",
  fieldGroupOther: "Autres",
  fieldGroupImagery: "Images du jour : NASA GIBS",
  gibsTrueColor: "RÉEL",
  gibsFalseColor: "FEU",
  gibsTipTrue: "Couleurs réelles",
  gibsTipFire: "Fausses couleurs feux : brûlis rouge sombre",
  varParticles: "FLUX",
  glyphParticles: "≈",
  varVolume: "NUAGE 3D",
  glyphVolume: "Q",
  levelAlone: "Lignes seules",
  levelAloneTitle: "Lignes seules : le champ disparaît, appuyer à nouveau le remet",
  creditsTrigger: "Sources",
  creditsHeading: "Données & crédits",
  creditsGfs: "Données de prévision : GFS 0.25° et sflux",
  creditsHrrr: "Données de prévision : HRRR 3 km, États-Unis contigus",
  creditsGefsAero: "Prévision d'aérosols : GEFS-Aerosols 0,25°, AOD et particules en surface",
  creditsCmaDust: "Prévision de poussière : CMA-CW v1.0/DUST (WMO SDS-WAS Asian Center) 0,15° sur l'Asie, via WMO WIS2",
  creditsSilam: "Prévision de la qualité de l’air : FMI SILAM v6.1 global 0,2°, CC BY 4.0",
  creditsCfs: "Prévision saisonnière : CFSv2, 9 mois, toutes les 6 heures",
  creditsEcmwf: "Contient des données ECMWF modifiées, CC BY 4.0",
  creditsIfsHres: "Adapté de l'IFS d'ECMWF par ECMWF, sous licence CC BY 4.0 ; via Open-Meteo ; IFS HRES ~9 km, rééchantillonné à 0,1°",
  creditsMrms: "Observations radar : MRMS, États-Unis contigus",
  creditsNexrad: "Radar individuel : réflectivité et vitesse radiale, États-Unis",
  creditsJma: "Précipitations radar : prévision immédiate JMA, Japon (remaillé)",
  creditsHimawari: "Imagerie satellite : Himawari-9 AHI, JMA, via NOAA Open Data (reprojeté)",
  creditsGoes: "Imagerie satellite : GOES-19 Est et GOES-18 Ouest ABI, NOAA NESDIS, via NOAA Open Data (reprojeté)",
  creditsMeteosat: "Imagerie satellite : contient des données Meteosat d'EUMETSAT modifiées {year} ; Meteosat-12 FCI, cycle horaire, CC-BY-4.0 (reprojeté)",
  creditsSounding: "Radiosondages : TEMP GTS via WIS2, services météo nationaux",
  creditsAirport: "METAR & TAF d'aéroports : services météo du monde via NOAA/NWS AWC",
  creditsFirms: "Feux actifs : LANCE FIRMS NRT, VIIRS 375 m et MODIS, NASA ESDIS",
  creditsGibs: "Images quotidiennes : réflectance corrigée MODIS et VIIRS, NASA ESDIS",
  creditsRadar: "Mosaïque radar",
  creditsBasemap: "Fond de carte : © contributeurs OpenStreetMap",
  creditsTerrain: "Relief : © Mapterhorn, sources des données d'élévation",
  creditsPeaks: "Noms et altitudes des sommets : CC0",
  creditsCode: "Code source : ringsaturn/xue",
  caseTag: "Cas",
  caseSummaryAria: "Résumé du cas",
  runCycle: "Réseau du modèle",
  recordSpan: "Période de la série",
  latestObservation: "Dernière observation",
  latestNowcast: "Dernière prévision immédiate",
  awaitingData: "En attente de données",
  validTimeLabel: "Échéance",
  observationTimeLabel: "Heure d'observation",
  statsAria: "Statistiques détaillées",
  statsCloseAria: "Fermer les statistiques",
  bufferedFrames: "En mémoire",
  downloadedBytes: "Téléchargé",
  formatLabel: "Format",
  formatZarr: "Zarr",
  preloadProgressAria: "Progression du préchargement des données de prévision",
  statDataset: "Jeu de données",
  statGrid: "Grille",
  statFrameCache: "Cache d'images",
  statDecodeTime: "Temps de décodage",
  statDecodeRate: "Débit de décodage",
  statViewport: "Échantillonnage",
  statConnection: "Connexion",
  awaitingManifest: "En attente du manifeste",
  legendPrateAria: "Échelle de couleurs des précipitations",
  timelineAria: "Commandes temporelles de la prévision",
  playAnimation: "Lancer l'animation",
  pauseAnimation: "Mettre l'animation en pause",
  playbackSpeed: "Vitesse de lecture",
  exportOpenAria: "Exporter l’animation",
  exportSheetAria: "Exporter l’animation",
  exportHeading: "Export",
  exportFormat: "Format",
  exportSize: "Taille",
  exportFps: "Cadence",
  exportRange: "Images",
  exportFrom: "De",
  exportTo: "À",
  exportRun: "Exporter",
  exportCancel: "Annuler",
  exportSummary: "{size}, {frames} images, {seconds} s, environ {bytes}",
  exportCapturing: "Capture {done}/{total}",
  exportEncoding: "Encodage {percent} %",
  exportFailed: "Échec de l’export",
  readingManifest: "Chargement du manifeste",
  forecastHourAria: "Échéance de prévision",
  forecastDaysAria: "Segments quotidiens de prévision",
  observationDaysAria: "Segments quotidiens",
  mapMenuAria: "Options de la carte",
  menuStats: "Statistiques détaillées",
  menuCopyDebug: "Copier les infos de débogage",
  errorTitle: "Données indisponibles",
  retry: "Réessayer",
  langPickerAria: "Langue",
  langPickerHeading: "Langue",
  themeToggleAria: "Basculer clair / sombre",
  viewGlobeAria: "Globe",
  viewTerrainAria: "Relief 3D",
  viewContoursAria: "Courbes de niveau",
  viewResetNorthAria: "Réorienter au nord",
  viewResetPitchAria: "Réinitialiser l’inclinaison",
  viewBoxAria: "Gros plan d’un orage : tracer un cadre",
  viewSectionAria: "Coupe verticale : tracer une ligne",
  viewDistanceAria: "Mesurer une distance : cliquer les points, recliquer le dernier pour finir",
  viewAreaAria: "Mesurer une surface : cliquer les sommets, recliquer le premier ou le dernier pour finir",
  particlesToggle: "Particules",
  particlesToggleAria: "Activer ou désactiver l'animation des particules de vent",

  dataInterrupted: "Chargement des données interrompu",
  errorHint: "{message}. Vérifiez que make mvp a été exécuté et que la page est servie via make serve.",
  loadFailed: "Échec du chargement",
  webglLost: "WebGL indisponible : quittez complètement le navigateur puis rouvrez-le",
  saveData: "éco",
  debugCopied: "Infos de débogage copiées",
  copyFailed: "Échec de la copie",
  bundleResident: "Lot entièrement en mémoire",
  viewportResident: "Zone visible entièrement chargée",
  streamingOnDemand: "Diffusion à la demande",
  receivingBundle: "Réception du lot de prévision",
  receivingBundlePercent: "Réception du lot {percent}%",
  readingIndex: "Lecture de l'index des données",
  initializingDecoder: "Initialisation du décodeur",
  framesReady: "{count} images prêtes",
  readingData: "Chargement des données",
  bundleLoadFailed: "Échec du chargement du lot de prévision",
  workerStartFailed: "Le worker de décodage n'a pas démarré",
  decodeFailed: "Échec du décodage",
  frameDecodeFailed: "Échec du décodage de l'image : {message}",
  legendAria: "Échelle de couleurs {label}",
  legendInflow: "Afflux chaud et humide",
  legendFront: "Zone frontale (gradient θe)",
  legendHotspot: "Point chaud (test contextuel à 3,9 µm)",
  legendFfwi: "Indice météorologique de feu de Fosberg",
  legendFwalert: "Humidité relative sous 30 % et rafales d’au moins 10 m/s",
  legendDustDust: "Poussière",
  legendDustThickHigh: "Nuages hauts épais",
  legendDustThinHigh: "Nuages hauts fins",
  legendDustMid: "Nuages moyens",
  legendDustLow: "Nuages bas chauds",
  legendDustDesert: "Surface désertique chaude",
  legendDustSurface: "Mer et terres végétalisées",
  legendTruecolorCloud: "Nuages et neige",
  legendTruecolorSea: "Mer",
  legendTruecolorLand: "Terres et végétation",
  legendTruecolorNightCloud: "Nuages la nuit (infrarouge)",
  legendTruecolorNightGround: "Ciel clair la nuit",
  legendPtypeRain: "Pluie",
  legendPtypeFreezingRain: "Pluie verglaçante",
  legendPtypeSnow: "Neige",
  legendPtypeIcePellets: "Grains de glace",
  legendDisrpBelow: "Sous le niveau 1,5 an",
  legendDisrp1p5: "≥ niveau 1,5 an",
  legendDisrp2: "≥ niveau 2 ans",
  legendDisrp5: "≥ niveau 5 ans",
  legendDisrp20: "≥ niveau 20 ans",
  legendCatLight: "Faible",
  legendCatModerate: "Modérée",
  legendCatModerateSevere: "Modérée–forte",
  legendCatSevere: "Forte",
  varLabelTmp2m: "Température à 2 m",
  varLabelPrate: "Intensité des précipitations",
  varLabelDswrf: "Rayonnement solaire",
  varLabelWind10m: "Vent à 10 m",
  varLabelWind80m: "Vent à 80 m",
  varLabelWind100m: "Vent à 100 m",
  varLabelCref: "Réflectivité radar composite",
  varLabelRefl3d: "Réflectivité radar 3D",
  varLabelCloud3d: "Eau nuageuse 3D",
  varLabelOrog: "Orographie",
  varLabelIr104: "Image infrarouge (température de brillance à 10,4 µm)",
  varLabelIr039: "Infrarouge à ondes courtes (température de brillance à 3,9 µm)",
  varLabelDustrgb: "RGB poussière (composite infrarouge)",
  varLabelDustcf: "Confiance poussière DEBRA",
  varLabelZhouye: "Confiance poussière ZHOUYE",
  varLabelTruecolor: "Couleur réelle le jour, nuages infrarouges la nuit",
  varLabelGust: "Rafales de vent",
  varLabelTcdc: "Nébulosité totale",
  varLabelCape: "Énergie potentielle convective disponible",
  varLabelCin: "Inhibition convective",
  varLabelVis: "Visibilité",
  varLabelDpt2m: "Point de rosée à 2 m",
  varLabelAptmp2m: "Température ressentie à 2 m",
  varLabelLcdc: "Nébulosité basse",
  varLabelMcdc: "Nébulosité moyenne",
  varLabelHcdc: "Nébulosité haute",
  varLabelPwat: "Eau précipitable",
  varLabelHpbl: "Hauteur de la couche limite planétaire",
  varLabelPtype: "Type de précipitation",
  varLabelTmpsfc: "Température de surface de la mer (température de peau sur terre)",
  varLabelIcec: "Couverture de glace de mer",
  varLabelIcetk: "Épaisseur de la glace de mer",
  varLabelWave: "Vagues : hauteur significative et direction",
  varLabelHtsgw: "Hauteur significative des vagues",
  varLabelPerpw: "Période de la houle primaire",
  varLabelDirpw: "Direction de la houle primaire",
  varLabelWindwave: "Mer du vent : hauteur significative et direction",
  varLabelSwell: "Houle : hauteur significative et direction (première composante)",
  varLabelWvhgt: "Hauteur significative de la mer du vent",
  varLabelWvper: "Période moyenne de la mer du vent",
  varLabelWvdir: "Direction de la mer du vent",
  varLabelSwhgt: "Hauteur significative de la houle (première composante)",
  varLabelSwper: "Période moyenne de la houle (première composante)",
  varLabelSwdir: "Direction de la houle (première composante)",
  varLabelAod: "Épaisseur optique des aérosols à 550 nm",
  varLabelAoddust: "Épaisseur optique des poussières",
  varLabelAodsalt: "Épaisseur optique du sel marin",
  varLabelAodsulf: "Épaisseur optique des sulfates",
  varLabelAodorg: "Épaisseur optique du carbone organique",
  varLabelAodbc: "Épaisseur optique du carbone suie",
  varLabelPm25: "Concentration de PM2,5 en surface",
  varLabelPm10: "Concentration de PM10 en surface",
  varLabelPm10dust: "Concentration de PM10 de poussière en surface",
  varLabelDustsfc: "Concentration de poussière en surface",
  varLabelTsoil1: "Température du sol, couche 1",
  varLabelTsoil2: "Température du sol, couche 2",
  varLabelTsoil3: "Température du sol, couche 3",
  varLabelTsoil4: "Température du sol, couche 4",
  varLabelSoilw1: "Humidité volumique du sol, couche 1",
  varLabelSoilw2: "Humidité volumique du sol, couche 2",
  varLabelSoilw3: "Humidité volumique du sol, couche 3",
  varLabelSoilw4: "Humidité volumique du sol, couche 4",
  varLabelPrmsl: "Pression au niveau de la mer",
  varLabelHeightAtLevel: "Géopotentiel {level} hPa",
  varLabelTempAtLevel: "Température {level} hPa",
  varLabelRhAtLevel: "Humidité relative {level} hPa",
  varLabelSpfhAtLevel: "Humidité spécifique {level} hPa",
  varLabelWindAtLevel: "Vent {level} hPa",
  varLabelQfluxAtLevel: "Flux de vapeur d'eau {level} hPa",
  varLabelVvelAtLevel: "Vitesse verticale à {level} hPa",
  varLabelThetaeAtLevel: "Température potentielle équivalente à {level} hPa",
  varLabelCatAtLevel: "Turbulence en air clair à {level} hPa (EDR)",
  legendSubtropicalHigh: "ligne 588",
  webglUnavailable: "Ce navigateur ne fournit pas de contexte WebGL2",
  pointerRequestFailed: "La requête du pointeur temps réel a renvoyé HTTP {status}",
  manifestRequestFailed: "La requête du manifeste a renvoyé HTTP {status}",
  bundleRequestFailed: "La requête du lot a renvoyé HTTP {status}",
  bundleTooLong: "Le lot dépasse la longueur déclarée par le manifeste",
  bundleLengthMismatch: "La longueur du lot ne correspond pas au manifeste",
  bundleChecksumMismatch: "Somme de contrôle du lot incorrecte",
  bundleRunMismatch: "Le réseau du lot ne correspond pas au manifeste",
  bundleMissingVariable: "Le lot ne contient pas le paramètre {id}",
  manifestMissingBundle: "Le manifeste n'a aucun lot pour le paramètre {id}",
  mosaicNoMembers: "Aucun jeu de données satellite de la mosaïque n'est disponible",

  probeAria: "Série temporelle au point",
  probeHint: "Lancez la lecture ou déplacez le curseur pour compléter la série",
  probeComplete: "Série complète",
  probeOutside: "Hors de la grille de ce jeu de données",
  probeNoData: "Aucune donnée à cette image",
  probeAwaiting: "En attente de cette image",
  probeModelElevationLabel: "Modèle",
  probeDemLabel: "DEM",
  probeCloseAria: "Fermer les données du point",
  cardCloseAria: "Fermer la fiche",

  centerHigh: "A",
  centerLow: "D",

  showcaseLink: "Cas",
  showcaseBack: "← Tous les cas",
  showcaseHome: "Prévision en direct",
  showcaseTitle: "Cas d'étude",
  showcaseHeading: "Des épisodes météo, rejoués",
  showcaseArchive: "archives",
  showcaseIntro:
    "Chaque cas est une tranche d'un épisode météorologique passé — un réseau de prévision archivé, ou des observations — passé par le même encodeur, découpé sur la région et les heures où il s'est produit.",
  showcaseMetaDescription:
    "Rejouer des épisodes météorologiques passés : jeux de données de prévision et de radar découpés pour typhons, pluies intenses, canicules et autres",
  showcaseLoading: "Chargement du catalogue de cas",
  showcaseEmpty: "Aucun cas publié pour l'instant",
  showcaseLoadFailed: "Échec du chargement du catalogue de cas : {message}",
  showcaseCaseMissing: "Aucun cas nommé {id}",
  showcaseEventLabel: "Épisode",
  showcaseRunLabel: "Réseau",
  showcaseSeriesLabel: "Début",
  showcaseRangeLabel: "Portée",
  showcaseSpanLabel: "Durée",
  showcaseRegionLabel: "Région",
  showcaseGridLabel: "Grille",
  showcaseSizeLabel: "Taille",
  showcaseVariablesLabel: "Champs",
  showcaseHours: "{count} h",
  showcaseCaseAria: "Ouvrir le cas {title}",
  showcaseListAria: "Liste des cas d'étude",

  tcTileTip: "Cyclones tropicaux",
  varTc: "TRAJET",
  glyphTc: "C",
  tcSheetAria: "Cyclones tropicaux",
  tcHeading: "Cyclones tropicaux",
  tcAllSystems: "Tous les systèmes numérotés",
  tcNone: "Aucun système actif",
  tcUnnamed: "Système sans nom",
  tcDisturbances: "Perturbations et dépressions",
  tcPotential: "Systèmes potentiels",
  tcPotentialShow: "Afficher {count} systèmes vus par les modèles seuls",
  tcModelOnly: "modèle seul",
  tcAgencies: "Prévisions officielles",
  tcModels: "Trajectoires modèles",
  tcMembers: "Membres d’ensemble",
  tcBest: "Meilleure trajectoire",
  tcOptionsAria: "Options des cyclones",
  tcHistoryHeading: "Cyclones tropicaux passés",
  tcHistoryIntro: "Chaque tempête numérotée de l'archive : les trajectoires de référence des centres, chaque prévision émise pour elle et l'écart de chacune.",
  tcHistorySeasonsAria: "Saison",
  tcHistoryBasinsAria: "Bassin",
  tcHistoryAll: "Tous",
  tcHistoryEmpty: "Aucune tempête avec prévisions pour cette saison et ce bassin",
  tcHistoryStormAria: "Ouvrir {name}",
  tcHistorySouthernNote: "Les saisons de l'hémisphère sud vont de juillet à juin et portent l'année où elles finissent : la saison {season} court de {from} à {to}.",
  tcPageTitle: "Cyclone tropical passé",
  tcPageMetaDescription: "Un cyclone tropical passé : les trajectoires de référence des centres, chaque prévision archivée pour lui et l'écart de chacune.",
  tcPageLoading: "Chargement de la tempête",
  tcPageMissing: "Aucune tempête archivée nommée {id}",
  tcPageFailed: "Échec du chargement de la tempête : {message}",
  tcPageIssue: "Instant",
  tcPageNoForecast: "aucune prévision ne part d'ici",
  tcPagePrev: "Prévision précédente",
  tcPageNext: "Prévision suivante",
  tcPageSources: "Trajectoires affichées",
  tcPageErrorsHeading: "Erreur de trajectoire, km",
  tcPageTruth: "Par rapport à la trajectoire de référence de",
  tcPageSource: "Source",
  tcPageErrorsMean: "Moyenne sur la tempête",
  tcPageErrorsThis: "La prévision sur la carte",
  tcPageErrorsNone: "Aucune prévision de cette tempête n'a encore été vérifiée par rapport à cette trajectoire de référence",
  tcPageNote: "Distance à la trajectoire de référence aux heures synoptiques, comptée seulement tant que le système est un cyclone tropical ou subtropical ; un ensemble est évalué par sa moyenne. Les prévisions officielles sont mises à côté des modèles lancés à la même heure, achevés après la publication de la prévision officielle.",
  tcPageId: "Identifiant ATCF",
  tcPageLife: "Durée de vie",
  tcPagePeak: "Vent maximal",
  tcPageForecasts: "Prévisions",
  tcCardSeasons: "Saisons",
  tcCardStorms: "Tempêtes",
  tcPageDetails: "Page de la tempête",
  tcPageSeasonList: "Toutes les tempêtes de la saison",
  tcCardBrowse: "Par saison",
  tcPageRadii: "Rayons de vent",
  tcLegendIntensity: "Intensité : trajectoire de référence américaine, vent sur 1 min",

  soundingTileTip: "Radiosondages",
  varSounding: "ALTITUDE",
  glyphSounding: "S",
  airportTileTip: "Observations d'aéroport",
  varAirport: "METAR",
  glyphAirport: "A",
  synopTileTip: "Stations météo au sol",
  varSynop: "SURFACE",
  glyphSynop: "W",
  radarTileTip: "Radar d’un site",
  varRadarSite: "SITE",
  glyphRadarSite: "D",
  radarProductAria: "Produit radar",
  radarLatest: "dernier",
  radarCloseAria: "Retour à la mosaïque",
  radarReflectivity: "Réflectivité",
  radarVelocity: "Vitesse radiale",
  stationSounding: "Radiosondage",
  stationAirport: "Aéroport",
  stationObserved: "Observé",
  stationFreezingLevel: "Isotherme 0 °C",
  stationPw: "Eau précipitable",
  stationCategory: "Catégorie de vol",
  stationVisibility: "Visibilité",
  stationQnh: "QNH",
  stationLevels: "Niveaux",
  stationSynop: "Station météo",
  stationHumidity: "Humidité",
  stationPrecipitation: "Précipitations",
  stationPressure: "Pression station",
  stationSeaLevelPressure: "Pression au niveau de la mer",
  stationSunshine: "Ensoleillement",
  stationSnowDepth: "Hauteur de neige",
  stationElevation: "Altitude",
  stationOpenSounding: "Ouvrir le sondage",
  stationPinHere: "Épingler ici",
  fireTileTip: "Feux actifs (NASA FIRMS, dernières 24 h)",
  varFire: "FEUX",
  glyphFire: "F",
  fireDetection: "Feu actif",
  fireAcquired: "Acquis",
  fireRadiativePower: "Puissance radiative",
  fireBrightness: "Température de brillance",
  fireConfidence: "Confiance",
  fireConfidenceLow: "faible",
  fireConfidenceNominal: "nominale",
  fireConfidenceHigh: "élevée",
  fireOverpass: "Passage",
  fireDay: "jour",
  fireNight: "nuit",
  aqTileTip: "Stations de qualité de l’air (PM2.5)",
  varAq: "PM2.5",
  glyphAq: "Q",
  aqStation: "Qualité de l’air",
  aqAgency: "Organisme",
  aqNetwork: "Réseau",
  aqPreliminary: "Données provisoires : non validées, susceptibles de changer",
  aqDayRange: "PM2.5, dernières 24 h",
  aqNearest: "Station de qualité de l’air la plus proche, {km} km",
  alertsTileTip: "Alertes météo en vigueur",
  varAlerts: "ALERTES",
  glyphAlerts: "!",
  alertsCardTitle: "Alertes",
  alertsInForceNow: "En vigueur",
  alertsAsOf: "au {time}",
  alertsLevel: "Niveau {level}",
  alertsUntilCancelled: "jusqu’à levée",
  alertsIssued: "émis {time}",
  alertCategoryRain: "Fortes pluies",
  alertCategoryFlood: "Inondation",
  alertCategoryLandslide: "Glissement de terrain",
  alertCategoryWind: "Vent",
  alertCategoryThunderstorm: "Orage",
  alertCategorySnowIce: "Neige et verglas",
  alertCategoryHeat: "Chaleur",
  alertCategoryCold: "Froid",
  alertCategoryFog: "Brouillard",
  alertCategoryDust: "Poussière",
  alertCategoryFire: "Risque d’incendie",
  alertCategoryAir: "Qualité de l’air",
  alertCategoryCoastal: "Littoral",
  alertCategoryMarine: "Marine",
  alertCategoryTsunami: "Tsunami",
  alertCategoryOther: "Autre",
  markerPlace: "Lieu",
  markerEvent: "Événement",
  markerSources: "Sources",
  caseMarkersAria: "Lieux et événements de ce cas",
  casePartsAria: "Parties de cet événement",
  riverHeading: "Débit des cours d’eau",
  riverTracksAria: "Simulation hydrologique",
  riverTrackAnalysis: "Analyse",
  riverTrackForecast: "Prévision {cycle}",
  riverKeyAria: "Débit rapporté au débit habituel",
  riverRatio2: "< 2× l’habituel",
  riverRatio10: "2–10×",
  riverRatio100: "10–100×",
  riverRatioMax: "≥ 100×",
  riverKeyField: "Coloré selon le débit, sur l’échelle du champ",
  riverExtents: "Zones inondées",
  riverGaugeHint: "Les cercles sont des stations : cliquer pour l’hydrogramme.",
  riverObserved: "mesuré",
  riverModelled: "modèle",
  riverPeaks: "Pics signalés",
  riverGaugeLoading: "chargement…",
  riverGaugeUnavailable: "indisponible",

  soundingObserved: "OBS",
  soundingModel: "MODÈLE",
  soundingNoModel: "aucun modèle à moins de 12 h",
  soundingLoading: "Lecture du sondage…",
  soundingUnavailable: "Sondage indisponible",
  soundingExpand: "Diagramme complet",
  soundingClose: "Fermer",
  soundingSheetHeading: "Sondage",
  soundingSheetAria: "Diagramme de sondage",

  // The comparison page (compare.html).
  compareLink: "Comparer",
  compareTitle: "Comparer les prévisions",
  compareHeading: "Comparaison des modèles",
  compareEyebrow: "point",
  compareIntro:
    "Tous les modèles de prévision en direct en un point, sur une même horloge : ce que chaque réseau annonce pour les heures à venir, à côté des messages de l'aéroport le plus proche.",
  compareMetaDescription:
    "Comparez les prévisions GFS, ECMWF, AIFS, IFS HRES et HRRR en un point, heure par heure, avec les messages METAR de l'aéroport le plus proche.",
  compareLatitude: "Latitude",
  compareLongitude: "Longitude",
  compareLocate: "Utiliser ma position",
  compareLocateFailed: "Position indisponible",
  compareOnMap: "Sur la carte",
  compareSpan5: "5 jours",
  compareSpan15: "15 jours",
  compareFieldsAria: "Champs à comparer",
  compareModelsAria: "Blocs de comparaison des modèles",
  compareLoading: "Lecture de {model}…",
  compareModelFailed: "{model} : {message}",
  compareOffGrid: "hors de la grille de ce modèle",
  compareNoModels: "Aucun modèle ne couvre ce point",
  compareHide: "Masquer",
  compareShow: "Afficher",
  comparePin: "Épingler en haut",
  compareHidden: "Modèles masqués",
  compareRun: "Réseau",
  compareObservationsFrom: "Messages de {icao}",
  compareNoAirport: "Aucun aéroport à moins de 40 km",
  compareHours: "Heures",
  compareNow: "maintenant",
  compareCells: "Chaque valeur est la maille du modèle la plus proche du point, jamais une interpolation ; les heures sont dans votre fuseau.",
  metricsMetaDescription: "Quand chaque run de prévision de Xue a été mis en ligne, mesuré depuis les workflows de publication : latence après l'heure de réseau, réseaux manquants et ce qui était en ligne à la clôture day-ahead de l'ERCOT.",
  metricsHeading: "Arrivée des runs",
  metricsEyebrow: "mesuré",
  metricsIntro: "Quand chaque run de prévision a été mis en ligne sur ce site, d'après les propres enregistrements des workflows de publication : l'instant où le pointeur en direct a été écrit, et combien de temps après l'heure de réseau du modèle.",
  metricsNotSla: "Ce sont des mesures, pas un niveau de service : Xue ne s'engage sur aucune disponibilité.",
  metricsGenerated: "Généré le {time}, {days} derniers jours",
  metricsLoading: "Lecture des métriques…",
  metricsEmpty: "Pas encore de métriques. Elles sont produites toutes les six heures à partir des workflows de publication ; revenez après la prochaine production.",
  metricsFailed: "Lecture des métriques impossible : {message}",
  metricsSourcesHeading: "Par source",
  metricsLatencyNote: "La latence va de l'heure de réseau à l'instant où le run est mis en ligne ; elle inclut donc le temps de production du modèle lui-même. Toutes les heures sont en UTC.",
  metricsTimelineNote: "Chaque bande couvre la fenêtre : une barre par réseau mis en ligne, à son heure de réseau, sa hauteur la latence rapportée à la plus longue de la source ; une marque sous la ligne est un réseau jamais arrivé.",
  metricsTypicalNote: "* Amont typique : une valeur d'expérience du délai après l'heure de réseau au bout duquel les données du modèle sont d'ordinaire complètes, pas une mesure. Vide quand il n'y en a pas.",
  metricsTimelineAria: "Arrivées de {model} sur la fenêtre",
  metricsCadence: "toutes les {hours} h",
  metricsLatest: "Dernier run",
  metricsLanded: "En ligne à",
  metricsLatency: "Latence",
  metricsMedian: "Médiane",
  metricsMax: "Max",
  metricsTypical: "Amont typique",
  metricsCycles: "Réseaux arrivés",
  metricsMissing: "Manquants",
  metricsMissingList: "Réseaux manquants",
  metricsRuns: "Exécutions du workflow",
  metricsOutcomeLanded: "en ligne",
  metricsOutcomeSkipped: "ignorée",
  metricsOutcomeDryRun: "essai à blanc",
  metricsOutcomeFailed: "échouée",
  metricsBacklog: "{count} exécutions du workflow pas encore lues ; la prochaine production les lira.",
  metricsDeadlinesHeading: "À l'échéance",
  metricsDeadlineIntro: "Pour chaque jour local, le run le plus récent déjà en ligne à l'échéance, et l'âge de son réseau à ce moment.",
  metricsSource: "Source",
  metricsCommonest: "Habituel",
  metricsNoneLive: "aucun",
  glyphAurora: "A",
  varAurora: "PROBA",
  varDis06: "6H",
  varDisrp: "RP",
  varUpstream: "AIRE",
  fieldGroupSpace: "Météo spatiale",
  fieldGroupFire: "Feux",
  modelGroupForecast: "Modèles de prévision",
  modelGroupRadar: "Radar",
  varLabelAurora: "Probabilité d'aurores visibles",
  varLabelDis06: "Débit des cours d'eau (moyenne sur 6 h)",
  varLabelDisrp: "Classe de période de retour",
  varLabelUpstream: "Surface drainée en amont",
  creditsAurora: "Météo spatiale : probabilité d'aurores, modèle OVATION du NOAA SWPC",
  creditsEfas: "Débit des cours d'eau : Copernicus EMS EFAS v5, Europe 1′ ; cas uniquement",
  creditsEra5: "Réanalyse : Copernicus C3S ERA5 (ECMWF), monde 0,25°, horaire, CC-BY-4.0 ; cas uniquement",
  creditsCams: "Analyse des aérosols : Copernicus CAMS (ECMWF), monde 0,4°, trihoraire, CC-BY-4.0 ; cas uniquement",
};
